/**
 * Toggle's the submenu when the user clicks on a parent menu link item,
 * when clicking somewhere else it hides the submenu again.
 */
const menuInit = () => {
  const header = document.querySelector('.header');
  const dropdowns = header.querySelectorAll('.menu__item--has-children');
  const active = 'menu__item--active';
  const activeMobileMenu = 'header-mobile-active';
  const toggler = document.querySelector('.header__toggler');
  const toggleActive = 'toggler--active';

  dropdowns.forEach((dropdown: HTMLLIElement) => {
    dropdown.addEventListener('click', () => {
      dropdown.classList.toggle(active);

      document.addEventListener('click', (event) => {
        if (!dropdown.contains(event.target as HTMLElement)) {
          dropdown.classList.remove(active);
        }
      });
    });
  });

  toggler.addEventListener('click', () => {
    toggler.classList.toggle(toggleActive);
    header.classList.toggle(activeMobileMenu);
  });
};

export default menuInit;
